module.exports = __webpack_public_path__ + "static/media/na-logo.ca74fd15.svg";